import { render, staticRenderFns } from "./OrderOK.vue?vue&type=template&id=6487d2a8&scoped=true&"
import script from "./OrderOK.vue?vue&type=script&lang=js&"
export * from "./OrderOK.vue?vue&type=script&lang=js&"
import style0 from "./OrderOK.vue?vue&type=style&index=0&id=6487d2a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6487d2a8",
  null
  
)

export default component.exports